import { consoleEvents } from '@pb/utils'

import { postProceedFail, resetCreditGuardData } from 'features/checkout/duck/actions'
import { handleProceedError } from 'features/checkout/duck/operations/postProceed/handleProceedError'
import { postConfirmCheckout } from 'features/checkout/requests'
import { ThunkResult } from 'redux/types'

export const operationAbortConfirmCreditGuardCheckout =
  (): ThunkResult<Promise<void>> => async (dispatch) => {
    try {
      dispatch(resetCreditGuardData())
      await postConfirmCheckout({
        abortPayment: true,
      })
    } catch (error) {
      consoleEvents.error('Failed to confirm checkout', error)
      dispatch(postProceedFail())
      dispatch(handleProceedError(error))
    }
  }
